import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  title: {
    fontSize: '2rem',
  },

  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

}))

export default styles
